import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './section.module.scss';
const Section = ({ children, title, height = 150, layout = 'row', RTL = false, size = 'sm', noPadding = false, useHash = false, border = true, }) => {
    const sectionStyle = useMemo(() => ({
        minHeight: `${height}px`,
    }), [height]);
    const sectionClass = useMemo(() => classNames(styles.section, border ? styles.border : ''), []);
    const bodyStyle = useMemo(() => ({
        alignItems: layout === 'column' ? 'center' : 'stretch',
        flexDirection: layout === 'column' ? 'row' : 'column',
    }), []);
    const bodyClass = useMemo(() => classNames(styles.body, {
        [styles[layout]]: true,
        [styles.no_padding]: noPadding,
        [styles.no_title]: !title,
        [styles.rtl]: RTL,
        [styles[`body_${size}`]]: true,
    }), [layout, title]);
    const isDarkMode = useMemo(() => isDark(), []);
    const headerClass = useMemo(() => {
        return classNames(styles.header, {
            [styles.header_rtl]: RTL,
            [styles[`header_${size}`]]: true,
            [styles.dark]: isDarkMode,
        }, 'rc-component-widget-heading');
    }, []);
    const getTitle = useMemo(() => {
        return useHash ? `# ${title}` : title;
    }, []);
    const getId = useMemo(() => {
        return `${title
            ?.replace(/\(|\)/gi, '')
            .replace('-', ' ')
            .split(' ')
            .map(f => f.trim().toLowerCase())
            .filter(f => f)
            .join('-')}`;
    }, []);
    return (_jsxs("div", { style: sectionStyle, className: sectionClass, children: [getTitle && (_jsx("div", { className: headerClass, id: getId, role: "heading", "aria-level": 3, children: getTitle })), _jsx("div", { style: bodyStyle, className: bodyClass, children: children })] }));
};
Section.displayName = 'Section';
export { Section };
